import { Record } from "immutable";

export class BankAccountRecord extends Record({
    id: null,
    account_entity_type: null,
    account_holder_name: null,
    account_limit: null,
    account_number: null,
    account_type: null,
    associate: null,
    bank_branch: null,
    company: null,
    is_key_account: null,
    partner_bank_account: null,
    status: null
}) {

    get JSONValues() {
        return {
            bank_branch: this.bank_branch && this.bank_branch.id,
            account_limit: this.account_limit,
            account_type: Number(this.account_type),
            account_holder_name: this.account_holder_name,
            status: this.status,
            is_key_account: this.is_key_account || false,
            id: this.id,
            account_number: this.account_number,
            company: this.company && this.company.id,
            partner_bank_account: this.partner_bank_account && this.partner_bank_account.id,
            account_entity_type: this.account_entity_type || 1
        };
    }
}

export class LenderAccountRecord extends Record({
    id: null,
    account_holder_name: null,
    account_number: null,
    account_type: null,
    bank_branch: null,
    company: null,
    partner_bank: null,
    status: null
}) {
    get JSONValues() {
        return {
            bank_branch: this.bank_branch && this.bank_branch.id,
            account_type: Number(this.account_type),
            account_holder_name: this.account_holder_name,
            status: this.status || 1,
            id: this.id,
            partner_bank: (this.partner_bank && this.partner_bank.id) || this.partner_bank,
            account_number: this.account_number,
            company: this.company && this.company.id,
        };
    }
}